let MAX = Math.max,
  MIN = Math.min,
  VERYSMALLNUMBER = 1e-6,
  VERTICAL = 'vertical';

function findNodeById (_nodes, _node) { // Need to change this function to take in actual id
  let nodes = _nodes,
    node = _node;
  return nodes.find(function (d) {
    return d.id === node || d.label === node;
  });
}
function createNodeLinks ({ nodes, links }) { // Creating the Source - Target links of each node
  nodes.forEach(_node => {
    let node = _node;
    node.props.sourceLinks = []; // create empty arrays of source and target links
    node.props.targetLinks = [];
  });

  /** Populate the source and target Links array of each node */
  links.forEach((_link, index) => {
    let link = _link,
      { source, target } = link.props;
    if (typeof source !== 'object') source = link.props.source = findNodeById(nodes, source); // find the source node
    if (typeof target !== 'object') target = link.props.target = findNodeById(nodes, target); // find the target node
    source.props.sourceLinks.push(link);
    target.props.targetLinks.push(link);

    link.props.index = index;
  });
}
function ascendingHeight (a, b) {
  return a.props.target.props.y0 - b.props.target.props.y0;
}
function ascendingWidth (a, b) {
  return a.props.target.props.x0 - b.props.target.props.x0;
}
function sortLinks (_links, orientation) {
  let links = _links;
  if (orientation === VERTICAL) {
    links.sort(ascendingWidth);
  } else {
    links.sort(ascendingHeight);
  }
  return links;
}
function createLinkDimensions ({ nodes }, props) {
  let orientation = props && props.orientation;
  for (const node of nodes) {
    if (orientation === VERTICAL) {
      let x0 = node.props.x0,
        x1 = x0,
        sortedSourceLinks = sortLinks(node.props.sourceLinks, orientation);
      for (const link of sortedSourceLinks) {
        link.props.x0 = x0 + link.props.linkWidth / 2;
        link.props.y0 = link.props.source.props.y1;
        x0 += link.props.linkWidth;
      }
      for (const link of node.props.targetLinks) {
        link.props.x1 = x1 + link.props.linkWidth / 2;
        link.props.y1 = link.props.target.props.y0;
        x1 += link.props.linkWidth;
      }
    } else {
      let y0 = node.props.y0,
        y1 = y0,
        sortedSourceLinks = sortLinks(node.props.sourceLinks);
      for (const link of sortedSourceLinks) {
        link.props.y0 = y0 + link.props.linkWidth / 2;
        link.props.x0 = link.props.source.props.x1;
        y0 += link.props.linkWidth;
      }
      for (const link of node.props.targetLinks) {
        link.props.y1 = y1 + link.props.linkWidth / 2;
        link.props.x1 = link.props.target.props.x0;
        y1 += link.props.linkWidth;
      }
    }
  }
}
function createNodeValues ({ nodes }) {
  nodes && nodes.forEach((_node) => {
    let totalSourceValue = 0,
      totalTargetValue = 0,
      node = _node;
    for (const { value } of node.props.sourceLinks) {
      totalSourceValue += Number(value);
    }
    for (const { value } of node.props.targetLinks) {
      totalTargetValue += Number(value);
    }
    node.props.value = MAX(totalSourceValue, totalTargetValue); // Assign value to each node based on the maximun of source and target Link values
  });
}

function createGraph (graph) {
  createNodeLinks(graph);
  createNodeValues(graph);
  return graph;
}

function traverseGraph ({ nodes }) {
  let currentSet = new Set(nodes), // Create initial set of unique nodes
    nextSet = new Set(), // Creates empty set of next nodes
    depth = 0;
    /* Traverse the graph using BFS and calculate the depth of each node */
  while (currentSet.size) {
    // eslint-disable-next-line no-loop-func
    currentSet.forEach((_node) => {
      let node = _node;
      node.props.depth = depth;
      for (const link of node.props.sourceLinks) {
        nextSet.add(link.props.target);
      }
    });
    if (++depth > nodes.length) {
      return false;
    };
    currentSet = nextSet;
    nextSet = new Set();
  }

  return true;
}
function createNodeDimensions (graphs, _props) {
  let props = _props,
    iterations = 6,
    { nodes } = graphs,
    maxDepth = MAX.apply(null, nodes.map((node) => { return node.props.depth; })) + 1; // Find maximum depth of the graph
  const columns = new Array(maxDepth);
  for (const node of nodes) {
    const layer = MAX(0, MIN(maxDepth - 1, node.props.depth));
    node.props.layer = layer;
    if (columns[layer]) columns[layer].push(node);
    else columns[layer] = [node];
  }
  setnodeXY(columns, maxDepth, props);
  if (props.nodeRelaxation) {
    for (let i = 0; i < iterations; ++i) { // number of iterations = 6
      const convergence = Math.pow(0.99, i),
        divergence = Math.max(1 - convergence, (i + 1) / 6); // Convergence and divergence factors are calculated based on the difference of iterative values from 1
      relaxSources(columns, convergence, divergence, props);
      relaxTargets(columns, convergence, divergence, props);
    }
  }
  createLinkDimensions(graphs, props);
}
function setnodeXY (_columns, _maxDepth, _props) {
  let columns = _columns,
    props = _props,
    maxDepth = _maxDepth,
    maxNodeWidth,
    minNodesLength,
    nodeGutter,
    nodeValueFactor,
    columngapFactor,
    orientation = props.orientation;
  maxNodeWidth = MAX.apply(null, columns[maxDepth - 1].map((node) => { return node.nodeWidth; }));
  columngapFactor = (orientation === VERTICAL) ? (props.height[1] - props.height[0] - maxNodeWidth) / (maxDepth - 1) : (props.width[1] - props.width[0] - maxNodeWidth) / (maxDepth - 1);

  nodeGutter = props.nodeGutter;
  minNodesLength = MAX.apply(null, columns.map((nodes) => {
    return nodes.length;
  }));
  if (orientation === VERTICAL) {
    if (((minNodesLength - 1) * nodeGutter) >= (props.width[1] - props.width[0]) || ((minNodesLength - 1) * nodeGutter) < 0) nodeGutter = props.nodeGutter = 10;
  } else {
    if (((minNodesLength - 1) * nodeGutter) >= (props.height[1] - props.height[0]) || ((minNodesLength - 1) * nodeGutter) < 0) nodeGutter = props.nodeGutter = 10;
  }
  nodeValueFactor = MIN.apply(null, columns.map((nodes) => {
    let totalValue = 0;
    for (const node of nodes) {
      totalValue += node.props.value;
    }
    return ((orientation === VERTICAL) ? ((props.width[1] - props.width[0] - ((nodes.length - 1) * nodeGutter)) / totalValue) : ((props.height[1] - props.height[0] - ((nodes.length - 1) * nodeGutter)) / totalValue));
  }));
  if (!columngapFactor || columngapFactor === Infinity || columngapFactor === -Infinity) columngapFactor = 0;
  if (!nodeValueFactor || nodeValueFactor === Infinity || nodeValueFactor === -Infinity) nodeValueFactor = 0;
  for (const nodes of columns) {
    if (orientation === VERTICAL) {
      let startX = props.width[0];
      for (const node of nodes) {
        for (const link of node.props.sourceLinks) { // Calculate the width of links of each sourcenode
          link.props.linkWidth = link.value * nodeValueFactor;
        }
        node.props.y0 = props.height[0] + (node.props.layer * columngapFactor);
        node.props.y1 = node.props.y0 + node.nodeWidth;
        node.props.x0 = startX;
        node.props.x1 = node.props.x0 + (nodeValueFactor * node.props.value);
        startX = node.props.x1 + nodeGutter;
      }
    } else {
      let startY = props.height[0];
      for (const node of nodes) {
        for (const link of node.props.sourceLinks) { // Calculate the width of links of each sourcenode
          link.props.linkWidth = link.value * nodeValueFactor;
        }
        node.props.x0 = props.width[0] + (node.props.layer * columngapFactor);
        node.props.x1 = node.props.x0 + node.nodeWidth;
        node.props.y0 = startY;
        node.props.y1 = node.props.y0 + (nodeValueFactor * node.props.value);
        startY = node.props.y1 + nodeGutter;
      }
    }
  }
}
// Reposition each node based on its incoming (target) links.
function relaxTargets (columns, alpha, beta, props) {
  let orientation = props && props.orientation;
  for (let i = 1, n = columns.length; i < n; ++i) {
    let targetShiftFactor;
    const column = columns[i];
    for (const target of column) {
      let y = 0,
        w = 0;
      for (const link of target.props.targetLinks) {
        let valueFactor = link.value * (target.props.layer - link.props.source.props.layer);
        y += targetTop(link.props.source, target, props) * valueFactor;
        w += valueFactor;
      }
      if (!(w > 0)) continue;
      if (orientation === VERTICAL) {
        targetShiftFactor = (y / w - target.props.x0) * alpha;
        target.props.x0 += targetShiftFactor;
        target.props.x1 += targetShiftFactor;
      } else {
        targetShiftFactor = (y / w - target.props.y0) * alpha;
        target.props.y0 += targetShiftFactor;
        target.props.y1 += targetShiftFactor;
      }
    }
    resolveCollisions(column, beta, props);
  }
}

// Reposition each node based on its outgoing (source) links.
function relaxSources (columns, alpha, beta, props) {
  let orientation = props && props.orientation;
  for (let n = columns.length, i = n - 2; i >= 0; --i) {
    let sourceShiftFactor;
    const column = columns[i];
    for (const source of column) {
      let y = 0,
        w = 0;
      for (const link of source.props.sourceLinks) {
        const { target } = link.props;
        let valueFactor = link.value * (target.props.layer - source.props.layer);
        y += sourceTop(source, target, props) * valueFactor;
        w += valueFactor;
      }
      if (!(w > 0)) continue;
      if (orientation === VERTICAL) {
        sourceShiftFactor = (y / w - source.props.x0) * alpha;
        source.props.x0 += sourceShiftFactor;
        source.props.x1 += sourceShiftFactor;
      } else {
        sourceShiftFactor = (y / w - source.props.y0) * alpha;
        source.props.y0 += sourceShiftFactor;
        source.props.y1 += sourceShiftFactor;
      }
    }
    resolveCollisions(column, beta, props);
  }
}

function resolveCollisions (nodes, beta, props) {
  const i = nodes.length >> 1,
    subject = nodes[i];
  let orientation = props && props.orientation;
  if (orientation === VERTICAL) {
    resolveCollisionsBottomToTop(nodes, subject.props.x0 - props.nodeGutter, i - 1, beta, props);
    resolveCollisionsTopToBottom(nodes, subject.props.x1 + props.nodeGutter, i + 1, beta, props);
    resolveCollisionsBottomToTop(nodes, props.width[1], nodes.length - 1, beta, props);
    resolveCollisionsTopToBottom(nodes, props.width[0], 0, beta, props);
  } else {
    resolveCollisionsBottomToTop(nodes, subject.props.y0 - props.nodeGutter, i - 1, beta, props);
    resolveCollisionsTopToBottom(nodes, subject.props.y1 + props.nodeGutter, i + 1, beta, props);
    resolveCollisionsBottomToTop(nodes, props.height[1], nodes.length - 1, beta, props);
    resolveCollisionsTopToBottom(nodes, props.height[0], 0, beta, props);
  }
}

// Push any overlapping nodes down.
function resolveCollisionsTopToBottom (nodes, _y, _i, beta, props) {
  let i = _i,
    y = _y,
    orientation = props && props.orientation;
  for (; i < nodes.length; ++i) {
    const node = nodes[i],
      dy = (y - (orientation === VERTICAL ? node.props.x0 : node.props.y0)) * beta;
    if (orientation === VERTICAL) {
      if (dy > VERYSMALLNUMBER) {
        node.props.x0 += dy;
        node.props.x1 += dy;
      }
      y = node.props.x1 + props.nodeGutter;
    } else {
      if (dy > VERYSMALLNUMBER) {
        node.props.y0 += dy;
        node.props.y1 += dy;
      }
      y = node.props.y1 + props.nodeGutter;
    }
  }
}

// Push any overlapping nodes up.
function resolveCollisionsBottomToTop (nodes, _y, _i, beta, props) {
  let i = _i,
    y = _y,
    orientation = props && props.orientation;
  for (; i >= 0; --i) {
    const node = nodes[i],
      dy = ((orientation === VERTICAL ? node.props.x1 : node.props.y1) - y) * beta;
    if (orientation === VERTICAL) {
      if (dy > VERYSMALLNUMBER) {
        node.props.x0 -= dy;
        node.props.x1 -= dy;
      }
      y = node.props.x0 - props.nodeGutter;
    } else {
      if (dy > VERYSMALLNUMBER) {
        node.props.y0 -= dy;
        node.props.y1 -= dy;
      }
      y = node.props.y0 - props.nodeGutter;
    }
  }
}

// Returns the target.y0 that would produce an ideal link from source to target.
function targetTop (source, target, props) {
  let orientation = props && props.orientation,
    shiftStart = (orientation === VERTICAL ? source.props.x0 : source.props.y0) - (source.props.sourceLinks.length - 1) * props.nodeGutter / 2;
  for (const link of source.props.sourceLinks) {
    let node = link.props.target,
      linkWidth = link.props.linkWidth;
    if (node === target) break;
    shiftStart += linkWidth + props.nodeGutter;
  }
  for (const link of target.props.targetLinks) {
    let node = link.props.source,
      linkWidth = link.props.linkWidth;
    if (node === source) break;
    shiftStart -= linkWidth;
  }
  return shiftStart;
}

// Returns the source.y0 that would produce an ideal link from source to target.
function sourceTop (source, target, props) {
  let orientation = props && props.orientation,
    shiftStart = (orientation === VERTICAL ? target.props.x0 : target.props.y0) - (target.props.targetLinks.length - 1) * props.nodeGutter / 2;
  for (const link of target.props.targetLinks) {
    let node = link.props.source,
      linkWidth = link.props.linkWidth;
    if (node === source) break;
    shiftStart += linkWidth + props.nodeGutter;
  }
  for (const link of source.props.sourceLinks) {
    let node = link.props.target,
      linkWidth = link.props.linkWidth;
    if (node === target) break;
    shiftStart -= linkWidth;
  }
  return shiftStart;
}

export {
  createGraph,
  createNodeLinks,
  createNodeValues,
  traverseGraph,
  createNodeDimensions
};
